'use client';
import React, { useState } from 'react';

interface ResourceEntry {
  name: string;
  category: string;
  address: string;
  contact: string;
  desc: string;
  nameOfAllah: string;
}

const CHICAGO_RESOURCES: ResourceEntry[] = [
  // Food
  { name: 'Greater Chicago Food Depository', category: 'Food', address: '4100 W Ann Lurie Pl, Chicago, IL 60632', contact: '(773) 247-3663', desc: 'Food bank serving Cook County with pantry network and mobile distributions', nameOfAllah: 'Ar-Razzaq (الرَّزَّاق)' },
  { name: 'Inspiration Kitchens', category: 'Food', address: '4715 W Chicago Ave, Chicago, IL 60651', contact: '(773) 384-4433', desc: 'Culinary job training and community meals on the West Side', nameOfAllah: 'Ar-Razzaq (الرَّزَّاق)' },
  { name: 'Chicago Islamic Network Food Pantry', category: 'Food', address: '1900 E 71st St, Chicago, IL 60649', contact: '(773) 643-4600', desc: 'Halal food pantry serving the South Side Muslim community', nameOfAllah: 'Ar-Razzaq (الرَّزَّاق)' },
  { name: 'Bronzeville Community Market', category: 'Food', address: '3500 S King Dr, Chicago, IL 60616', contact: 'bronzevillecommunity.org', desc: 'Fresh produce and community food access in Bronzeville', nameOfAllah: 'Ar-Razzaq (الرَّزَّاق)' },
  // Health
  { name: 'Sinai Community Institute', category: 'Health', address: '1500 S Fairfield Ave, Chicago, IL 60608', contact: '(773) 257-6400', desc: 'Community health services, mental health, and social services for underserved communities', nameOfAllah: 'Ash-Shafi (الشَّافِي)' },
  { name: 'Access Community Health Network', category: 'Health', address: 'Multiple locations across Chicago', contact: '(312) 526-2000', desc: 'Federally qualified health centers providing affordable primary care', nameOfAllah: 'Ash-Shafi (الشَّافِي)' },
  { name: 'Heartland Health Centers', category: 'Health', address: '7350 N Rogers Ave, Chicago, IL 60626', contact: '(773) 338-3800', desc: 'Comprehensive primary care and behavioral health services', nameOfAllah: 'Ash-Shafi (الشَّافِي)' },
  { name: 'Muslim Mental Health Initiative', category: 'Health', address: 'Chicago Metro Area', contact: 'muslimmentalhealth.com', desc: 'Culturally competent mental health resources for Muslim communities', nameOfAllah: 'Ash-Shafi (الشَّافِي)' },
  // Education
  { name: 'Universal School', category: 'Education', address: '8313 Lemont Rd, Burr Ridge, IL 60527', contact: '(630) 986-0001', desc: 'K-12 Islamic school serving the Chicago Muslim community', nameOfAllah: 'Al-Alim (الْعَلِيم)' },
  { name: 'Darul Qasim', category: 'Education', address: '1225 N Swift Rd, Addison, IL 60101', contact: '(630) 628-9750', desc: 'Islamic seminary and educational institute offering courses in Islamic sciences', nameOfAllah: 'Al-Alim (الْعَلِيم)' },
  { name: 'Chicago Public Library — Woodson Regional', category: 'Education', address: '9525 S Halsted St, Chicago, IL 60628', contact: '(312) 747-6900', desc: 'Major South Side library with African American history collection and free resources', nameOfAllah: 'Al-Alim (الْعَلِيم)' },
  { name: 'City Colleges of Chicago', category: 'Education', address: 'Multiple campuses across Chicago', contact: '(312) 553-2500', desc: 'Affordable community college education and workforce training', nameOfAllah: 'Al-Alim (الْعَلِيم)' },
  // Housing
  { name: 'Metropolitan Tenants Organization', category: 'Housing', address: '1 N Dearborn St, Chicago, IL 60602', contact: '(773) 292-4988', desc: 'Tenant rights advocacy, counseling, and anti-displacement resources', nameOfAllah: 'Al-Wali (الْوَلِيّ)' },
  { name: 'Chicago Housing Authority', category: 'Housing', address: '60 E Van Buren St, Chicago, IL 60605', contact: '(312) 742-8500', desc: 'Public housing assistance and Section 8 voucher programs', nameOfAllah: 'Al-Wali (الْوَلِيّ)' },
  { name: 'Neighborhood Housing Services', category: 'Housing', address: '1279 N Milwaukee Ave, Chicago, IL 60622', contact: '(773) 329-4010', desc: 'Homeownership counseling, foreclosure prevention, and affordable housing', nameOfAllah: 'Al-Wali (الْوَلِيّ)' },
  // Income
  { name: 'Chicago Urban League', category: 'Income', address: '4510 S Michigan Ave, Chicago, IL 60653', contact: '(773) 285-5800', desc: 'Economic empowerment, workforce development, and entrepreneurship programs', nameOfAllah: 'Al-Mughni (الْمُغْنِي)' },
  { name: 'Women\'s Business Development Center', category: 'Income', address: '8 S Michigan Ave, Chicago, IL 60603', contact: '(312) 853-3477', desc: 'Business development, loans, and training for women entrepreneurs', nameOfAllah: 'Al-Mughni (الْمُغْنِي)' },
  { name: 'ICNA Relief Chicago', category: 'Income', address: 'Chicago Metro Area', contact: 'icnarelief.org', desc: 'Emergency financial assistance, Zakat distribution, and economic support', nameOfAllah: 'Al-Mughni (الْمُغْنِي)' },
  // Reentry
  { name: 'Safer Foundation', category: 'Reentry', address: '571 W Jackson Blvd, Chicago, IL 60661', contact: '(312) 922-2200', desc: 'Reentry services, job training, and transitional housing for returning citizens', nameOfAllah: 'Al-Afuww (الْعَفُوّ)' },
  { name: 'Heartland Alliance — Reentry', category: 'Reentry', address: '208 S LaSalle St, Chicago, IL 60604', contact: '(312) 660-1300', desc: 'Comprehensive reentry support including housing, employment, and legal aid', nameOfAllah: 'Al-Afuww (الْعَفُوّ)' },
  { name: 'Chicago Help Initiative', category: 'Reentry', address: 'Chicago South Side', contact: 'chicagohelpinitiative.org', desc: 'Transitional housing and support services for formerly incarcerated individuals', nameOfAllah: 'Al-Afuww (الْعَفُوّ)' },
  // Justice
  { name: 'CAIR Chicago', category: 'Justice', address: '17 N State St, Chicago, IL 60602', contact: '(312) 212-1520', desc: 'Civil rights advocacy, legal services, and community empowerment for Muslims', nameOfAllah: 'Al-Muqsit (الْمُقْسِط)' },
  { name: 'Chicago Lawyers\' Committee for Civil Rights', category: 'Justice', address: '100 N LaSalle St, Chicago, IL 60602', contact: '(312) 630-9744', desc: 'Pro bono legal services for civil rights and racial justice', nameOfAllah: 'Al-Muqsit (الْمُقْسِط)' },
  { name: 'Metropolitan Tenants Organization', category: 'Justice', address: '1 N Dearborn St, Chicago, IL 60602', contact: '(773) 292-4988', desc: 'Housing justice advocacy and tenant rights legal support', nameOfAllah: 'Al-Muqsit (الْمُقْسِط)' },
  // Community
  { name: 'Masjid Al-Ihsan', category: 'Community', address: '321 E Pershing Rd, Chicago, IL 60653', contact: 'masjidihsan.org', desc: 'Masjid and Islamic Institute serving the Bronzeville community under Imam Abdullah Madyun', nameOfAllah: 'Al-Wadud (الْوَدُود)' },
  { name: 'Inner-City Muslim Action Network (IMAN)', category: 'Community', address: '2744 W 63rd St, Chicago, IL 60629', contact: '(773) 434-4626', desc: 'Community organizing, health, arts, and economic development on the South Side', nameOfAllah: 'Al-Wadud (الْوَدُود)' },
  { name: 'Muslim Community Center', category: 'Community', address: '4380 N Elston Ave, Chicago, IL 60641', contact: '(773) 725-9047', desc: 'Islamic center offering education, social services, and community programs', nameOfAllah: 'Al-Wadud (الْوَدُود)' },
  { name: 'Council of Islamic Organizations of Greater Chicago', category: 'Community', address: 'Chicago Metro Area', contact: 'ciogc.org', desc: 'Umbrella organization coordinating Chicago Muslim community institutions', nameOfAllah: 'Al-Wadud (الْوَدُود)' },
];

const TABS = ['All', 'Food', 'Health', 'Education', 'Housing', 'Income', 'Reentry', 'Justice', 'Community'] as const;
type Tab = typeof TABS[number];

const CATEGORY_COLORS: Record<string, string> = {
  Food: '#16a34a',
  Health: '#dc2626',
  Education: '#2563eb',
  Housing: '#7c3aed',
  Income: '#d97706',
  Reentry: '#0891b2',
  Justice: '#be185d',
  Community: '#059669',
};

const CATEGORY_ICONS: Record<string, string> = {
  Food: '🌾',
  Health: '🏥',
  Education: '📚',
  Housing: '🏠',
  Income: '💼',
  Reentry: '🔓',
  Justice: '⚖️',
  Community: '🤝',
};

export default function ChicagoResourceWidget() {
  const [activeTab, setActiveTab] = useState<Tab>('All');
  const [search, setSearch] = useState('');
  const [expanded, setExpanded] = useState<string | null>(null);

  const filtered = CHICAGO_RESOURCES.filter(r => {
    const matchTab = activeTab === 'All' || r.category === activeTab;
    const matchSearch = !search || r.name.toLowerCase().includes(search.toLowerCase()) || r.desc.toLowerCase().includes(search.toLowerCase()) || r.category.toLowerCase().includes(search.toLowerCase());
    return matchTab && matchSearch;
  });

  return (
    <>
      <style>{`
        .crg-wrap {
          background: #f8f7f4;
          border-radius: 0;
        }

        /* Header */
        .crg-header {
          background: linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%);
          padding: 28px 28px 24px;
          border-radius: 12px 12px 0 0;
          position: relative;
          overflow: hidden;
        }
        .crg-header::before {
          content: '';
          position: absolute;
          top: -40px; right: -40px;
          width: 180px; height: 180px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
        }
        .crg-header-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.5);
          margin: 0 0 6px;
          position: relative;
          z-index: 1;
        }
        .crg-header-title {
          font-family: 'Amiri', serif;
          font-size: clamp(20px, 3vw, 28px);
          font-weight: 700;
          color: #fff;
          margin: 0 0 6px;
          position: relative;
          z-index: 1;
        }
        .crg-header-sub {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: rgba(255,255,255,0.65);
          margin: 0;
          position: relative;
          z-index: 1;
        }

        /* Search */
        .crg-search-wrap {
          padding: 16px 20px;
          background: #fff;
          border-bottom: 1px solid rgba(59,130,246,0.1);
        }
        .crg-search {
          width: 100%;
          padding: 10px 14px 10px 36px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          color: #1e3a8a;
          background: rgba(59,130,246,0.04);
          border: 1px solid rgba(59,130,246,0.15);
          border-radius: 7px;
          outline: none;
          transition: border-color 0.2s;
          box-sizing: border-box;
          position: relative;
        }
        .crg-search:focus { border-color: rgba(59,130,246,0.4); }
        .crg-search-wrap-inner {
          position: relative;
        }
        .crg-search-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 14px;
          color: rgba(30,58,138,0.35);
          pointer-events: none;
        }

        /* Tabs */
        .crg-tabs {
          display: flex;
          overflow-x: auto;
          scrollbar-width: none;
          background: #fff;
          border-bottom: 1px solid rgba(59,130,246,0.1);
          padding: 0 8px;
        }
        .crg-tabs::-webkit-scrollbar { display: none; }
        .crg-tab {
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 10px 14px;
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          background: none;
          border: none;
          border-bottom: 2px solid transparent;
          cursor: pointer;
          transition: all 0.2s;
          color: rgba(30,58,138,0.45);
          flex-shrink: 0;
        }
        .crg-tab.active {
          color: #1e3a8a;
          border-bottom-color: #3b82f6;
        }
        .crg-tab:hover:not(.active) {
          color: rgba(30,58,138,0.7);
        }

        /* Resource grid */
        .crg-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 12px;
          padding: 16px;
          background: #f8f7f4;
          max-height: 520px;
          overflow-y: auto;
        }
        .crg-card {
          background: #fff;
          border: 1px solid rgba(30,58,138,0.08);
          border-radius: 9px;
          overflow: hidden;
          transition: border-color 0.2s, box-shadow 0.2s;
          cursor: pointer;
        }
        .crg-card:hover {
          border-color: rgba(30,58,138,0.2);
          box-shadow: 0 3px 14px rgba(30,58,138,0.07);
        }
        .crg-card.expanded {
          border-color: rgba(30,58,138,0.3);
          box-shadow: 0 4px 18px rgba(30,58,138,0.09);
        }
        .crg-card-top {
          padding: 14px 16px 10px;
        }
        .crg-card-cat {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-family: 'DM Sans', sans-serif;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 3px 8px;
          border-radius: 4px;
          margin-bottom: 8px;
        }
        .crg-card-name {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 600;
          color: #1e3a8a;
          margin: 0 0 4px;
          line-height: 1.3;
        }
        .crg-card-desc {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: rgba(30,58,138,0.55);
          line-height: 1.55;
          margin: 0;
        }
        .crg-card-expanded {
          padding: 0 16px 14px;
          border-top: 1px solid rgba(59,130,246,0.07);
          margin-top: 10px;
        }
        .crg-card-detail {
          display: flex;
          align-items: flex-start;
          gap: 6px;
          margin-top: 8px;
        }
        .crg-card-detail-icon {
          font-size: 12px;
          color: rgba(30,58,138,0.4);
          flex-shrink: 0;
          margin-top: 1px;
        }
        .crg-card-detail-text {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: rgba(30,58,138,0.6);
          margin: 0;
          line-height: 1.5;
        }
        .crg-card-allah {
          font-family: 'Amiri', serif;
          font-size: 13px;
          color: rgba(30,58,138,0.4);
          margin-top: 8px;
          display: block;
        }

        /* Footer */
        .crg-footer {
          padding: 12px 20px;
          background: #fff;
          border-top: 1px solid rgba(59,130,246,0.08);
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 0 0 12px 12px;
        }
        .crg-footer-count {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: rgba(30,58,138,0.45);
        }
        .crg-footer-link {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          color: #1e3a8a;
          text-decoration: none;
          font-weight: 600;
          transition: opacity 0.2s;
        }
        .crg-footer-link:hover { opacity: 0.7; }

        @media (max-width: 640px) {
          .crg-grid { grid-template-columns: 1fr; max-height: 400px; }
          .crg-header { padding: 20px 16px 18px; }
        }
      `}</style>

      <div className="crg-wrap" style={{ border: '1px solid rgba(59,130,246,0.12)', borderRadius: 12, overflow: 'hidden' }}>
        {/* Header */}
        <div className="crg-header">
          <p className="crg-header-label">Chicago · South Side · Bronzeville</p>
          <h3 className="crg-header-title">Muslim Resource Guide — Chicago</h3>
          <p className="crg-header-sub">Community resources across 8 caretaking domains · {CHICAGO_RESOURCES.length} verified organizations</p>
        </div>

        {/* Search */}
        <div className="crg-search-wrap">
          <div className="crg-search-wrap-inner">
            <span className="crg-search-icon">🔍</span>
            <input
              type="text"
              className="crg-search"
              placeholder="Search resources, categories, services..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* Tabs */}
        <div className="crg-tabs">
          {TABS.map(tab => (
            <button
              key={tab}
              className={`crg-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab !== 'All' && <span>{CATEGORY_ICONS[tab]}</span>}
              {tab}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="crg-grid">
          {filtered.length === 0 ? (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px 20px', color: 'rgba(30,58,138,0.4)', fontFamily: "'DM Sans', sans-serif", fontSize: 14 }}>
              No resources found. Try a different search or category.
            </div>
          ) : (
            filtered.map((r, i) => {
              const color = CATEGORY_COLORS[r.category] ?? '#3b82f6';
              const isExpanded = expanded === `${r.name}-${i}`;
              return (
                <div
                  key={i}
                  className={`crg-card ${isExpanded ? 'expanded' : ''}`}
                  onClick={() => setExpanded(isExpanded ? null : `${r.name}-${i}`)}
                >
                  <div className="crg-card-top">
                    <div className="crg-card-cat" style={{ background: `${color}12`, color }}>
                      <span>{CATEGORY_ICONS[r.category]}</span>
                      {r.category}
                    </div>
                    <p className="crg-card-name">{r.name}</p>
                    <p className="crg-card-desc">{r.desc}</p>
                  </div>
                  {isExpanded && (
                    <div className="crg-card-expanded">
                      <div className="crg-card-detail">
                        <span className="crg-card-detail-icon">📍</span>
                        <p className="crg-card-detail-text">{r.address}</p>
                      </div>
                      <div className="crg-card-detail">
                        <span className="crg-card-detail-icon">📞</span>
                        <p className="crg-card-detail-text">{r.contact}</p>
                      </div>
                      <span className="crg-card-allah">Name of Allah: {r.nameOfAllah}</span>
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>

        {/* Footer */}
        <div className="crg-footer">
          <span className="crg-footer-count">Showing {filtered.length} of {CHICAGO_RESOURCES.length} resources</span>
          <a href="/subhaal/masjid-al-ihsan/resource-guide" className="crg-footer-link">
            Full Resource Guide →
          </a>
        </div>
      </div>
    </>
  );
}
